import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ProgressBarComponent {

  @Input() Score: number = 0;
  @Input() MaxScore: number = 0;

  public progressStroke: number = 0;
  public progress: number = 0;

  constructor() {
    this.completeCalculations();
  }

  ngOnChanges() {
    this.completeCalculations();
  }
  completeCalculations() {
    if (this.MaxScore > 0) {
      this.calcProgress();
      this.calcStrokeOffset();
    }
  }
  calcStrokeOffset() {
    const r = 40;
    const c = 2 * Math.PI * r;

    if(this.MaxScore == 0){
      this.progressStroke = 251.2
    }else{
      this.progressStroke = c - (c * this.progress) / 100;
    }
    
  }
  calcProgress() {
    if (this.MaxScore > 0) {
      this.progress =  Math.round((this.Score / this.MaxScore) * 100);
    }
    return 0;
  }

}
